import moment from 'moment';
import { FIRST_OF_MONTH, MID_OF_MONTH } from '../constants/date';

const timesheetStartsFirstDayOfMonth = (value) => {
  return moment(value).date() === FIRST_OF_MONTH;
};

const timesheetStartsMidOfMonth = (value) => {
  return moment(value).date() === MID_OF_MONTH;
};

export { timesheetStartsFirstDayOfMonth, timesheetStartsMidOfMonth };
